import { MpcGetTripsResponseDto } from '@/features/trips/MpcGetTripsResponseDto';
import { TripUpdateRequest } from '@/features/trips/TripUpdateRequest';
import { MpcTripUpdateResponse } from '@/features/trips/MpcTripUpdateResponse';
import { PassingTimeUpdateRequest } from '@/features/trips/PassingTimeUpdateRequest';
import { MpcPassingTimeUpdateResponse } from '@/features/trips/MpcPassingTimeUpdateResponse';
import { BookingData, BookingNoShowPage, DeleteBookingNoShowRequest } from './BookingNoShowModels';

export const ITripsApiId = Symbol.for('ITripsApi');

export interface ITripsApi {
    /**
     * Fetches all trips
     * @param lineNumber ID of line to fetch departures for.
     * @param calendarDay Time to fetch departures for.
     */
    getTrips(lineNumber: string, calendarDay?: string): Promise<MpcGetTripsResponseDto>;

    /**
     * Creates a new trip.
     * @param tripId ID of trip to fetch stops for.
     * @param calendarDay Date and time to fetch stops for.
     */
    createTrip(tripId: string, calendarDay: string): Promise<void>;

    /**
     * Updates a trip.
     * @param data updated trip data.
     */
    updateTrip(data: TripUpdateRequest): Promise<MpcTripUpdateResponse>;

    /**
     * Updates a passing time.
     * @param data updated passing time data.
     */
    updatePassingTime(data: PassingTimeUpdateRequest): Promise<MpcPassingTimeUpdateResponse>;

    /**
     * Registers passenger no show for booking.
     * @param data booking no show data.
     */
    registerBookingNoShow(data: BookingData): Promise<MpcTripUpdateResponse>;

    /**
     * Deletes passenger no show for booking by composite identity.
     */
    deleteBookingNoShow(request: DeleteBookingNoShowRequest): Promise<void>;

    /**
     * Get list of booking no shows.
     * @param page list pagination.
     */
    getBookingNoShows(page: BookingNoShowPage, filters: any): Promise<void>;

    /**
     * Completes the trip.
     * @param tripId trip ID
     * @param operatingDay origin departure of the trip
     */
    completeTrip(tripId: string, operatingDay: string): Promise<void>;

    /**
     * Cancels the current trip.
     * @param tripId trip ID
     * @param operatingDay origin departure of the trip
     */
    cancelTrip(tripId: string, operatingDay: string): Promise<void>;
}
